import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import * as printJS from 'print-js'

@Component({
  selector: 'app-pdf-view',
  templateUrl: './pdf-view.component.html',
  styleUrls: ['./pdf-view.component.scss']
})
export class PdfViewComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  srcPrintPdf =  this.RESOURCE_SERVER_URL + '/assets/images/print.png';
  constructor(public dialogRef: MatDialogRef<PdfViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    //onInit
  }
  async onPrintPDF() {
    const pdfFile = new Blob([this.data['file']], {
      type: "application/pdf"
    });
    const pdfUrl = URL.createObjectURL(pdfFile);
    printJS(pdfUrl);
  }
}
